import { VIDEO_EDITOR_TRACK_TYPE } from "./constants";
import { clipHasCanvasLayout } from "./clipProperties";
import { getClipTimelineDuration } from "./projectSchema";

export const getVisualClipsAtPlayhead = ({ edl, playhead }) =>
  Object.values(edl?.clips?.byId || {})
    .filter((clip) => clipHasCanvasLayout(clip))
    .filter((clip) => {
      const start = clip.position || 0;
      const end = start + getClipTimelineDuration({ clip });
      return playhead >= start && playhead < end;
    })
    .sort((left, right) => {
      const typeDelta =
        (left.type === VIDEO_EDITOR_TRACK_TYPE.IMAGE ? 1 : 0) -
        (right.type === VIDEO_EDITOR_TRACK_TYPE.IMAGE ? 1 : 0);
      if (typeDelta !== 0) {
        return typeDelta;
      }
      return (Number(left.layerIndex) || 0) - (Number(right.layerIndex) || 0);
    });

export const getVisualLayerZIndex = (clip) => {
  const layer = (Number(clip?.layerIndex) || 0) + 1;
  return clip?.type === VIDEO_EDITOR_TRACK_TYPE.IMAGE ? layer + 20 : layer;
};
